/**
 * Форматирует размер файла в удобный для чтения формат (Байты, КБ, МБ, ГБ)
 * @param {number} bytes Размер в байтах
 * @param {number} decimals Количество десятичных знаков (по умолчанию 2)
 * @returns {string} Отформатированный размер с единицами измерения
 */
export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Байт';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Форматирует дату в локализованную строку
 * @param {Date|string} date Дата для форматирования
 * @param {object} options Опции форматирования для Intl.DateTimeFormat
 * @returns {string} Отформатированная дата
 */
export const formatDate = (date, options = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
}) => {
  if (!date) return 'Н/Д';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('ru-RU', options).format(dateObj);
};

/**
 * Форматирует число, добавляя разделители групп разрядов
 * @param {number} number Число для форматирования
 * @param {number} decimals Количество десятичных знаков
 * @returns {string} Отформатированное число
 */
export const formatNumber = (number, decimals = 0) => {
  if (number === null || number === undefined) return 'Н/Д';
  
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(number);
};

/**
 * Форматирует длительность в секундах в формат ЧЧ:ММ:СС или ММ:СС
 * @param {number} seconds Длительность в секундах
 * @param {boolean} showHours Показывать ли часы (по умолчанию true)
 * @returns {string} Отформатированная длительность
 */
export const formatDuration = (seconds, showHours = true) => {
  if (!seconds && seconds !== 0) return 'Н/Д';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  
  const pad = (num) => String(num).padStart(2, '0');
  
  if (showHours || hours > 0) {
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  }
  
  return `${pad(minutes)}:${pad(secs)}`;
}; 